import { del, get, set } from 'idb-keyval';
import { useApp, type Project } from './store';

/** Loads a saved project for this file, if it has any real work in it. */
export async function loadProject(key: string): Promise<Project | null> {
  try {
    const p = (await get(key)) as Project | undefined;
    if (!p || p.version !== 1) return null;
    const hasWork = p.text.trim().length > 0 || p.marks.length > 0 || Object.keys(p.kickoffs).length > 0;
    return hasWork ? p : null;
  } catch {
    return null;
  }
}

export async function forgetProject(key: string) {
  try {
    await del(key);
  } catch {
    /* storage unavailable */
  }
}

/** Saves the current project to IndexedDB a moment after each change. */
export function startAutosave() {
  let timer: number | undefined;
  return useApp.subscribe((state, prev) => {
    if (!state.fileKey || state.project === prev.project || state.restorable) return;
    const key = state.fileKey;
    const project = { ...state.project, savedAt: Date.now() };
    window.clearTimeout(timer);
    timer = window.setTimeout(() => {
      set(key, project).catch(() => {
        /* private mode or storage full: the app still works, it just won't remember */
      });
    }, 600);
  });
}
